import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { ReportsFilter, reportsFilterInitialState } from '../../models/ReportsFilter';
import { Nullable } from 'primereact/ts-helpers';

type SerializableReportsFilter = Omit<ReportsFilter, 'dates'> & {
  dates: Nullable<(number | null)[]>;
};

export interface filterState {
  value: SerializableReportsFilter;
}

const initialState: filterState = { value: { ...reportsFilterInitialState, dates: [] } };

const serializeDates = (dates: ReportsFilter['dates']): SerializableReportsFilter['dates'] => {
  if (dates == null) return dates;
  return dates.map(date => date?.getTime() ?? null);
};

const deserializeDates = (dates: SerializableReportsFilter['dates']): ReportsFilter['dates'] => {
  if (dates == null) return dates;
  return dates.map(timestamp => (timestamp === null ? null : new Date(timestamp)));
};

export const filterReportsSlice = createSlice({
  name: 'reportsFilter',
  initialState,
  reducers: {
    setReportsFilter: {
      reducer: (state: filterState, action: PayloadAction<SerializableReportsFilter>) => {
        state.value = action.payload;
      },
      prepare: (filters: ReportsFilter) => ({
        payload: {
          ...filters,
          dates: serializeDates(filters.dates),
        },
      }),
    },
  },
});

export const selectedReportsFilter = createSelector([(state: RootState) => state.reportsFilter.value], filters => ({
  ...filters,
  dates: deserializeDates(filters.dates),
}));

export const { setReportsFilter } = filterReportsSlice.actions;

export default filterReportsSlice.reducer;
